export default __webpack_public_path__ + "static/media/investment-acquisition-3.f4da3b5f.svg";